<template>
  <div class="page rowBackgroundHomepage">

    <div class="showSmallScreenOnly">
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank color-inherit" @click="addUser" v-if="currentRole === 'simple'"
        :disabled="$engine.rights.rightIs('business_members_ajouter', false)">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
      <f7-fab class="leftfav button-fab bottomButton floatingButtonToolbarBlank color-inherit" @click="addGroupMember" v-if="currentRole === 'group'"
        :disabled="$engine.rights.rightIs('teams_ajouter', false)">
        <f7-icon f7="add"></f7-icon>
      </f7-fab>
    </div>

    <div class="page-content">
      <div class="layoutTop"/>
      <div class="listPage">
        <b-row>
          <b-col sm="12" class="showLargeScreenOnly">
            <div class="firstButtonMarginLeft" v-if="currentRole === 'simple'">
              <f7-button class="milkyBlockBlack new-button-white firstBlock mt-0 mb-3" @click="addUser"
                :disabled="canAccessMember">
                <f7-icon f7="add"></f7-icon>
                <span>{{ $t('businessMembers.add_member') }}</span>
              </f7-button>
            </div>
            <div class="firstButtonMarginLeft" v-if="currentRole === 'group'">
              <f7-button class="milkyBlockBlack new-button-white firstBlock mt-0 mb-3" @click="addGroupMember"
                :disabled="canAccessTeam">
                <f7-icon f7="add"></f7-icon>
                <span>{{ $t('businessMembers.add_team') }}</span>
              </f7-button>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <div class="contactButtonContainer filterTitle">
              <f7-grid no-gutter>
                <f7-col width="50" class="pilotageTabController">
                  <f7-link tab-link=".membersTab1"
                    v-if="currentRole === 'simple'"
                    class="pilotageLink" style="border-top-left-radius: 10px;"
                    :class="getColorActive"
                    @click="changeCurrentRole('simple')" active>
                    {{ $t('businessMembers.members_label') }}
                  </f7-link>
                  <f7-link tab-link=".membersTab1"
                    v-else
                    class="pilotageLink" style="border-top-left-radius: 10px;"
                    :class="getColorUnactive"
                    @click="changeCurrentRole('simple')" active>
                    {{ $t('businessMembers.members_label') }}
                  </f7-link>
                </f7-col>
                <f7-col width="50" class="pilotageTabController" :disabled="$engine.rights.rightIs('teams_consulter', false)">
                  <f7-link tab-link=".membersTab2"
                    v-if="currentRole === 'group'"
                    class="pilotageLink" style="border-top-right-radius: 10px;"
                    :class="getColorActive"
                    @click="changeCurrentRole('group')">
                    {{ $t('businessMembers.teams_label') }}
                  </f7-link>
                  <f7-link tab-link=".membersTab2"
                    v-else
                    class="pilotageLink" style="border-top-right-radius: 10px;"
                    :class="getColorUnactive"
                    :style="[$engine.rights.rightIs('teams_consulter', false) ? {'background-color':'grey'} : {}]"
                    @click="changeCurrentRole('group')">
                    {{ $t('businessMembers.teams_label') }}
                  </f7-link>
                </f7-col>
              </f7-grid>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <f7-tabs class="itemList">
              <f7-tab class="membersTab1" active>
                <f7-searchbar
                  id="members-sb"
                  class="members-sb webdatalist"
                  search-list="#members-list"
                  found=".members-found"
                  :cancel-link="$t('common.cncl')"
                  :placeholder="$t('businessMembers.srch_in_members')"
                  @searchbar:search="onSearch"
                  @searchbar:clear="onClear">
                </f7-searchbar>
                <div class="layoutSubtitle"/>
                <f7-list class="searchbar-not-found">
                  <f7-list-item title="Nothing found"></f7-list-item>
                </f7-list>
                <f7-list class="members-found" id="members-list">
                  <cm-account-membersList-list v-bind:userAccounts="userAccounts" :filterBy="filterBy"></cm-account-membersList-list>
                </f7-list>
              </f7-tab>

              <f7-tab class="membersTab2">
                <f7-searchbar
                  class="webdatalist"
                  search-list="#group-list"
                  :cancel-link="$t('common.cncl')"
                  :placeholder="$t('businessMembers.srch_in_teams')"
                  @searchbar:search="onTeamSearch"
                  @searchbar:clear="onTeamSearchClear">
                </f7-searchbar>
                <div class="layoutSubtitle"/>
                <f7-list class="searchbar-not-found">
                  <f7-list-item title="Nothing found"></f7-list-item>
                </f7-list>
                <f7-list class="group-found" id="group-list">
                  <cm-members-group-list :membersGroup="membersGroup"
                    :filterBy="teamFilterBy">
                  </cm-members-group-list>
                </f7-list>
              </f7-tab>
            </f7-tabs>
          </b-col>
        </b-row>
      <div class="toolbarPageBottomBlank"></div>
    </div>
    </div>
  </div>
</template>

<script>
import AccountMembersList from './CMAccountMembersPage/CMAccountMembersList.vue'
import AccountMembersGroupList from './CMAccountMembersPage/CMAccountMembersGroupList.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import design from '@/design/design.json'
// import {get} from '@/helpers/api'
import pageNavBar from '@/components/common/pageNavBar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'userAccounts',
  components: {
    'cm-account-membersList-list': AccountMembersList,
    'cm-members-group-list': AccountMembersGroupList,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      BusinessMembersListLabel: '',
      currentRole: 'simple',
      design: design.menu,
      userAccounts: [],
      userAccts: [],
      filterBy: '',
      membersGroup: [],
      teamFilterBy: ''
    }
  },
  mounted: function () {
    let that = this
    this.refreshPage()
    this.$bus.$off('refresh-page-member')
    this.$bus.$on('refresh-page-member', () => {
      that.refreshPage()
    })
    // this.$engine.accounts.getUserAccountsNotInGroup()
    //   .then(response => {
    //     if (response.status === 200) {
    //       this.$settings.currentAccount.notInGroup = response.data.userAccounts
    //     }
    //   })
  },
  created () {
    this.BusinessMembersListLabel = this.$i18n.t('businessMembers.members_list_name')
    /* Turn off all buses events */
    this.$bus.$off('sendbox-filtered')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    this.$bus.$off('refresh-inbox-list-cache')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
  },
  beforeDestroy: function () {
    this.setUserAccountsBis()
  },
  computed: {
    getColorActive: function () {
      /* return {
        'tabActive_DD': this.$engine.user.currentService.name === 'Direct Debit',
        'tabActive_P': this.$engine.user.currentService.name === 'Payments',
        'tabActive': this.$engine.user.currentService.name === 'Direct Payments'
      } */
      return 'tabActive'
    },
    getColorUnactive: function () {
      /* return {
        'tabActive_DD': this.$engine.user.currentService.name === 'Direct Debit',
        'tabActive_P': this.$engine.user.currentService.name === 'Payments',
        'tabActive': this.$engine.user.currentService.name === 'Direct Payments'
      } */
      return 'tabUnactive'
    },
    canAccessMember: function () {
      return this.$engine.rights.rightIs('business_members_ajouter', false) || this.$engine.rights.rightIs('rights_profile_consulter', false)
    },
    canAccessTeam: function () {
      return this.$engine.rights.rightIs('teams_ajouter', false) || this.$engine.rights.rightIs('teams_editer_add_groupe', false) || this.$engine.rights.rightIs('teams_editer_add_membre', false)
    }
  },
  watch: {
    currentRole: function () {
      if (this.currentRole === 'group') {
        this.BusinessMembersListLabel = this.$i18n.t('businessMembers.teams_list_name')
      } else {
        this.BusinessMembersListLabel = this.$i18n.t('businessMembers.members_list_name')
      }
    }
  },
  methods: {
    onSearch: function (query, found) {
      this.filterBy = query
    },
    onTeamSearch: function (query, found) {
      this.teamFilterBy = query
    },
    onTeamSearchClear: function () {
      this.teamFilterBy = ''
    },
    changeCurrentRole (role) {
      if (role === 'group' && this.$engine.rights.rightIs('teams_consulter', false)) {
        return
      }
      if (this.currentRole !== role) {
        this.currentRole = role
      }
      if (this.currentRole === 'simple') {
        this.Dom7('.membersTab2').removeClass('active')
        this.Dom7('.membersTab1').addClass('active')
      } else if (this.currentRole === 'group') {
        this.Dom7('.membersTab1').removeClass('active')
        this.Dom7('.membersTab2').addClass('active')
      }
    },
    onClear: function () {
      this.filterBy = ''
    },
    setUserAccounts () {
      const that = this
      var userAccountList = {}
      var idsMember = []
        // Verifie que toutes les applications (formulaires) sont présents dans l'application
      for (var i = 0; i < that.$settings.currentAccount.userAccts.length; i++) {
        if (that.$settings.currentAccount.userAccts[i].type === '2' && !idsMember.includes(that.$settings.currentAccount.userAccts[i].id)) {
          idsMember.push(that.$settings.currentAccount.userAccts[i].id)
          var firstLetter = that.$settings.currentAccount.userAccts[i].login.substr(0, 1).toUpperCase()
          if (!userAccountList.hasOwnProperty(firstLetter)) {
            userAccountList[firstLetter] = []
          }
          var subtitle
          switch (that.$settings.currentAccount.userAccts[i].active) {
            case '0':
              subtitle = this.$i18n.t('businessMembers.unknown_user')
              break
            case '1':
              subtitle = this.$i18n.t('businessMembers.disabled_user')
              break
            case '2':
              subtitle = this.$i18n.t('businessMembers.enabled_user')
              break
          }
          userAccountList[firstLetter].push({
            login: that.$settings.currentAccount.userAccts[i].login,
            name: that.$settings.currentAccount.userAccts[i].name,
            active: subtitle,
            id: that.$settings.currentAccount.userAccts[i].id,
            clearance_payments: 3,
            clearance_directDebit: 3,
            clearance_directPayments: 3
          })
          userAccountList[firstLetter].sort()
        }
      }
      this.userAccounts = this.orderKeys(userAccountList)
    },
    setUserAccountsBis () {
      const that = this
      var userAccountList = {}
      userAccountList[3] = {}
      userAccountList[2] = {}
      userAccountList[1] = {}
      userAccountList[0] = {}
      var idsMember = []
        // Verifie que toutes les applications (formulaires) sont présents dans l'application
      for (var i = 0; i < that.$settings.currentAccount.userAccts.length; i++) {
        if (that.$settings.currentAccount.userAccts[i].type === '2' && !idsMember.includes(that.$settings.currentAccount.userAccts[i].id)) {
          idsMember.push(that.$settings.currentAccount.userAccts[i].id)
          var clearance = 3
          var firstLetter = that.$settings.currentAccount.userAccts[i].login.substr(0, 1).toUpperCase()
          if (!userAccountList[clearance].hasOwnProperty(firstLetter)) {
            userAccountList[clearance][firstLetter] = []
          }
          var subtitle
          switch (that.$settings.currentAccount.userAccts[i].active) {
            case '0':
              subtitle = this.$root.$t('businessMembers.unknown_user')
              break
            case '1':
              subtitle = this.$root.$t('businessMembers.disabled_user')
              break
            case '2':
              subtitle = this.$root.$t('businessMembers.enabled_user')
              break
          }
          userAccountList[clearance][firstLetter].push({
            login: that.$settings.currentAccount.userAccts[i].login,
            name: that.$settings.currentAccount.userAccts[i].name,
            active: subtitle,
            id: that.$settings.currentAccount.userAccts[i].id,
            clearance_payments: 3,
            clearance_directDebit: 3,
            clearance_directPayments: 3
          })
          userAccountList[clearance][firstLetter].sort()
        }
      }
      for (var c in userAccountList) {
        userAccountList[c] = this.orderKeys(userAccountList[c])
      }
      this.userAccounts = this.orderKeys(userAccountList)
    },
    setMembersGroups: function () {
      var membersGroupList = {}
      this.$engine.accounts.fetchGroup().then(resp => {
        var getMembersGroup = this.$engine.accounts.getMembersGroup()
        // console.log(getMembersGroup)
        for (var j = 0; j < getMembersGroup.length; j++) {
          var tab = getMembersGroup
          // console.log(tab)
          var firstLetter = tab[j].name.substr(0, 1).toUpperCase()
          if (!membersGroupList.hasOwnProperty(firstLetter)) {
            membersGroupList[firstLetter] = []
          }
          // console.log('Tab J')
          // console.log(tab[j])
          membersGroupList[firstLetter].push({
            name: tab[j].name,
            id_business: tab[j].id_business,
            id_team: tab[j].id_team,
            email_notification: tab[j].email_notification,
            amount_notification: tab[j].amount_notification,
            groups: tab[j].groups
          })
          membersGroupList[firstLetter].sort()
        }
        this.membersGroup = this.orderKeys(membersGroupList)
      })
      .catch(error => {
        this.handleError(error) // mixins errorHandlerMixins
      })
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })

      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    orderKeysInv: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 > k2) return -1
        else if (k1 < k2) return +1
        else return 0
      })

      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    addUser () {
      let that = this
      // that.$f7.popup('.AddAccountMember')
      loadPage(that, {url: '/accountMembers/add/'})
    },
    addGroupMember () {
      let that = this
      this.$engine.settings.set({currentMemberGroup: []})
      loadPage(that, {url: '/accountMembers/addMemberGroup/'})
    },
    refreshPage () {
      let that = this
      that.$engine.accounts.getUserAccountsNotInGroup()
        .then(response => {
          if (response.status === 200) {
            that.$settings.currentAccount.userAccts = response.data.userAccounts
            that.$settings.currentAccount.notInGroup = response.data.userAccounts
            that.setUserAccountsBis()
            if (this.$engine.rights.rightIs('teams_consulter', true)) {
              that.setMembersGroups()
            }
          }
        })
        .catch(error => {
          this.handleError(error) // mixins errorHandlerMixins
        })
    },
    OpenFormsPage () {
      const that = this
      that.$f7.popup('.forms-page')
    }
  }
}
</script>

<style scoped>
/* .pilotageLink.active {
  background-color: #12bcf1;
  color: white;
} */

.toolbarPageBottomBlank {
  height: 115px !important;
}

.color-inherit {
  color: inherit;
}
</style>
